import React from "react";
import { Container } from "reactstrap";
import List from "./List";

import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import { PLATFORM_NAME } from "../../CommonData/Data/constant";

const Deposit = ({ t }) => {
  document.title = t("document.title.deposit", { PLATFORM_NAME });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={t("deposit.breadcrumbs.list.title")}
            navigation={true}
            breadcrumbItem={t("deposit.breadcrumbs.list.breadcrumbItem")}
          />
          <List />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Deposit);
